Game.Utils.Controls = {

	cursor: null,
	action: null,

	init: function() {

		// Controls.
		this.cursor = game.input.keyboard.createCursorKeys();
		this.action = game.input.keyboard.addKey( Phaser.Keyboard.SPACEBAR );

	},

};
